import { useState } from "react";

function BooleanInputButton({ChangeOptions, options}) {
  const [isAnimating, setIsAnimating] = useState(false); 

  const handleInputFocus = () => {
    setIsAnimating(true);  
  };

  const handleInputBlur = () => {
    setIsAnimating(false); 
  };

  return (
    <>
    {options.map((element, index) => {
      return (
        <input
          key={index} 
          type="text"
          value={element}  
          onChange={(e) => ChangeOptions(e.target.value, index)}
          onFocus={handleInputFocus}  
          onBlur={handleInputBlur}  
          className={`p-3 mx-3 rounded-md shadow-sm transition-all duration-200 ease-in-out flex-1 text-center 
            border-[1px] border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-gray-500 
            hover:border-gray-400 hover:bg-gray-50 placeholder:text-gray-500 text-gray-700
            ${isAnimating ? "animate-pulse" : ""}`}
          placeholder="İçeriği buraya yazın..."  
        />
      );
    })}
    </>
  );
}

export default BooleanInputButton;
